import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


export interface Selection{
  key:string,
  nonce: number;
}

@Injectable({
  providedIn: 'root'
})
export class SelectMenuOptionService {

  constructor() { }

  key ='';
  private _nonce=0;
  readonly tick$ = new Subject<number>();

  // readonly selection$ = this.subject.asObservable();

  setKey(k:string){
    this.key = k;
    this._nonce = 0;
    this.tick$.next(this._nonce);
  }
}
